import { createFileRoute } from "@tanstack/react-router";
import { DangerScreen } from "./-settings/DangerScreen";

export const Route = createFileRoute("/$workspace/$project/settings/danger")({
  staticData: { title: "Danger zone" },
  component: DangerScreen,
});
